const filterBy = ({ variants, compatibleValues, optionName }) => variants.filter((item) => {
  const variant = 'node' in item ? item.node : item;
  const targetOption = variant.selectedOptions.find(
    (option) => option.name === optionName
  );
  if (!targetOption) return true;

  return compatibleValues.includes(targetOption.value);
});

export default function findCompatibleVariants({ compatibleModels, compatibleSizes, variants }) {
  let compatibleVariants = variants;

  if (compatibleModels?.length) {
    // Filter out incompatible models
    compatibleVariants = filterBy({ variants: compatibleVariants, compatibleValues: compatibleModels, optionName: 'Model' })
  }

  if (compatibleSizes?.length) {
    // Filter out incompatible sizes
    compatibleVariants = filterBy({ variants: compatibleVariants, compatibleValues: compatibleSizes, optionName: 'Size' })
  }

  if (!compatibleVariants.length) {
    // No compatible sizes were found - show all variants.
    compatibleVariants = variants;
    compatibleSizes = [];
    compatibleModels = [];
  }

  return { compatibleVariants, updatedCompatibleSizes: compatibleSizes, updatedCompatibleModels: compatibleModels };
}
